export default __webpack_public_path__ + "static/media/trello-right.eb491713.svg";